import PropTypes from 'prop-types'
import React from 'react'

export default function Alert({ children }: props) {
  const body = (typeof children !== 'string') ?
    children : (
      <p>
        {children}
      </p>
    )

  return (
    <div uk-alert="true" className="Alert uk-alert-danger">
      {body}
    </div>
  )
}

Alert.propTypes = {
  children: PropTypes.node,
}



// WEBPACK FOOTER //
// ./src/components/Alert/Alert.js